import { evidenceFor, evidenceLabels, evidenceTerm, evidenceMissingTerm, evidenceDetails, evidenceAttempts } from '../../utils/diagnosticEvidence';

export default function DiagnosticEvidenceView({ result, metric, language = 'cs' }) {
  const evidence = evidenceFor(result, metric);
  if (!evidence) return null;
  const l = evidenceLabels(language);
  return (
    <section className="my-4 rounded-lg border border-slate-400 dark:border-slate-600 bg-slate-100 dark:bg-slate-800 p-4 text-slate-900 dark:text-slate-100 text-sm break-words">
      <h3 className="font-semibold mb-2">{l.title} · {metric}</h3>
      <p className="text-slate-700 dark:text-slate-300">{l.scope}: {l.url} {evidence.scope?.url || l.unavailable} · {l.device} {evidence.scope?.device || l.unavailable} · {l.state}: {evidenceTerm(evidence.state, language)}</p>
      <p className="text-slate-700 dark:text-slate-300">{l.basis}</p>
      {evidence.observations.map((o, i) => (
        <div key={`${o.id}-${i}`} className="border border-slate-300 dark:border-slate-600 p-3 my-2 rounded">
          <p>{l.subject}: {o.subject} · {l.predicate}: {evidenceTerm(o.predicate, language)} ({o.predicate}) · {l.object}: {o.object}</p>
          <p>{l.state}: {evidenceTerm(o.level, language)} · {l.role}: {evidenceTerm(o.elementRole || 'unknown', language)} · {l.source}: {o.sourceRef || l.unavailable}</p>
          {evidenceDetails(o.details, language).map((line, index) => <p key={index}>{line}</p>)}
          {!!o.missingLinks?.length && <p>{l.gaps}: {o.missingLinks.map(link => evidenceMissingTerm(link, language)).join('; ')}</p>}
        </div>
      ))}
      {!!evidenceAttempts(evidence, language).length && <h4 className="font-semibold">{l.attempts}</h4>}
      {evidenceAttempts(evidence, language).map((lines, index) => (
        <div key={index} className="border border-slate-300 dark:border-slate-600 p-2 my-2 rounded">
          {lines.map((line, i) => <p key={i}>{line}</p>)}
        </div>
      ))}
      <p>{l.gaps}: {evidence.missingLinks.length ? evidence.missingLinks.map(link => evidenceMissingTerm(link, language)).join('; ') : l.unavailable}</p>
      <p className="text-slate-700 dark:text-slate-300">{l.caution}</p>
    </section>
  );
}